import { memo } from 'react';

import { isEmptyArray, isNotEmptyArray } from '@travel/utils';

import TaxFee from 'components/TaxFee';

import { Translate } from 'core/translate';
import type { TaxAndFee } from 'ProviderRatePlan-Types';

type PageName = 'booking_step' | 'provider_information';

type Props = {
  /** custom classnames */
  className?: string;
  excludedFeeRemarkClassName?: string;
  /** Array of exclude taxes */
  excludeTaxes?: Array<TaxAndFee>;
  /** Array of include taxes */
  includeTaxes?: Array<TaxAndFee>;
  shouldHideTitle?: boolean;
  titleClassName?: string;
  taxTitleClassName?: string;
  shouldShowIndirectProviderDisclaimer?: boolean;
  pageName?: PageName;
  isIndirectProvider?: boolean;
};

const TaxAndFeeSection = memo(function TaxAndFeeSection(props: Props) {
  const {
    includeTaxes = [],
    excludeTaxes = [],
    shouldShowIndirectProviderDisclaimer = false,
    pageName = 'booking_step',
    isIndirectProvider,
  } = props;

  if (isEmptyArray(props.includeTaxes) && isEmptyArray(props.excludeTaxes)) {
    return null;
  }

  return (
    <div data-testid="taxAndFeeSection-wrapper" className={props.className}>
      {!props.shouldHideTitle && (
        <h3 className={props.titleClassName}>
          <Translate id="Common_Price_Details.Taxes_Fees.Title" />
        </h3>
      )}

      <TaxFee
        taxFee={includeTaxes}
        taxTitleClassName={props.taxTitleClassName}
        isIndirectProvider={isIndirectProvider}
      />
      <TaxFee
        taxFee={excludeTaxes}
        taxTitleClassName={props.taxTitleClassName}
        isExclude
        isIndirectProvider={isIndirectProvider}
      />
      {isNotEmptyArray(props.excludeTaxes) && (
        <p className={props.excludedFeeRemarkClassName}>
          * <Translate id="Common_Price_Details.Taxes_Fees.Disclaimer" />
        </p>
      )}
      {shouldShowIndirectProviderDisclaimer && (
        <p className={props.excludedFeeRemarkClassName}>
          *{' '}
          <Translate
            id={
              pageName === 'booking_step'
                ? 'Common_Price_Details.Out_To_Out.Taxes_Fees.Charge_Includes_Estimated_Taxes_Fees'
                : 'Provider_Info.Out_To_Out.Room_List.Plan_Details.Tax_Disclaimer'
            }
          />
        </p>
      )}
    </div>
  );
});

export default TaxAndFeeSection;
